<template>
  <div>
    <Menu />
    <pulse-loader
      :loading="loading"
      :color="color"
      :size="size"
      class="vue-loader"
    ></pulse-loader>
    <div class="container main">
      <div class="row">
        <div class="col-md-12">
          <SectionTitle
            title="Gerenciar brasão"
            description="Permite alterar o brasão do município para aparecer nos relatórios"
            url="/administracao"
          />
        </div>
        <div class="col-md-12">
          <b-card title="" tag="article" class="card-logo mb-2">
            <b-card-text>
              <div class="logo-preview-wrapper">
                <!-- Brasão atual -->
                <div class="logo-preview">
                  <!-- <div class="logo-title">Brasão atual</div> -->
                  <img :src="imageUrl" v-if="imageUrl" />
                </div>
              </div>

              <!-- Upload -->
              <b-form-file
                v-model="image"
                placeholder="Nenhum arquivo selecionado"
                drop-placeholder="Arraste o arquivo aqui..."
                @change="onFileChange"
                accept=".jpg,.jpeg,.png"
                browse-text="Escolher arquivo"
                class="mt-3"
              ></b-form-file>
            </b-card-text>

            <div class="save-button-wrapper">
              <b-button variant="primary" @click="salvarLogo()">
                Salvar
              </b-button>
            </div>

            <div class="example-container">
              <div class="example-diagram">
                <div class="example-box"></div>
                <div class="example-width">80 px</div>
                <div class="example-height">70 px</div>
              </div>

              <div class="example-text">Tamanho recomendado da imagem</div>
            </div>
          </b-card>
        </div>
      </div>
    </div>
    <Footer />
  </div>
</template>

<script>
import Menu from '@/components/Menu'
import Footer from '@/components/Footer'
import SectionTitle from '@/components/SectionTitle'
import PulseLoader from 'vue-spinner/src/PulseLoader.vue'

export default {
  name: 'GerenciarBrasao',
  metaInfo: {
    title: 'Gerenciar brasão',
    titleTemplate: null,
  },
  components: {
    Menu,
    Footer,
    SectionTitle,
    PulseLoader,
  },
  data() {
    return {
      image: undefined,
      imageUrl: '',
      loading: false,
      size: '40px',
      color: '#0D98BB',
    }
  },
  mounted() {
    this.imageUrl =
      'https://esusfeedback.com.br/' + this.$store.state.infoMunicipio.brasao
  },
  methods: {
    /**
     * Cria uma imagem a partir do arquivo upado
     * @param file
     */
    createImage(file) {
      const reader = new FileReader()
      reader.onload = (e) => {
        const image = new Image()
        image.src = e.target.result
        image.onload = () => {
          //   const { height, width } = image
          //   if (height > 200 || width > 200) {
          //     this.$toast.error(
          //       'Altura e largura não devem excede 200px.',
          //       'Erro',
          //       {
          //         position: 'topCenter',
          //       }
          //     )
          //     return false
          //   }
          this.image = file
          this.imageUrl = e.target.result
          return true
        }
      }
      reader.readAsDataURL(file)
    },

    /**
     * Manipula a seleção de um arquivo
     * @param file
     */
    onFileChange(file) {
      if (!file) {
        return
      }

      const uploadedFile = file.target.files[0]

      if (
        !['image/png', 'image/jpeg', 'image/jpg'].includes(uploadedFile.type)
      ) {
        return
      }

      const sizeKb = uploadedFile.size / 1024

      if (sizeKb > 300) {
        this.$toast.error('O arquivo deve conter no máximo 300 KB.', 'Erro', {
          position: 'topRight',
        })
        return
      }

      this.createImage(uploadedFile)
    },

    /**
     * Salvar o brasão
     */
    salvarLogo() {
      if (this.image == undefined) {
        this.$toast.error('Selecione um arquivo.', 'Erro', {
          position: 'topRight',
        })
        return
      }

      const allowedTypes = [
        'image/jpeg',
        'image/png',
        'image/webp',
        'image/gif',
      ]
      if (!allowedTypes.includes(this.image.type)) {
        this.$toast.error('Tipo de arquivo não permitido.', 'Erro', {
          position: 'topRight',
        })
        return
      }

      const MAX_SIZE = 300 * 1024
      if (this.image.size > MAX_SIZE) {
        this.$toast.error('O arquivo deve conter no máximo 300 KB.', 'Erro', {
          position: 'topRight',
        })
        return
      }

      this.loading = true

      let formData = new FormData()
      let url = '/app/municipio/brasao/' + this.$store.state.cod_ibge
      formData.append('file', this.image)
      this.$api
        .post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        })
        .then((response) => {
          if (response.data.error == false) {
            this.$store.commit('setBrasao', this.imageUrl)
            this.$toast.success(response.data.message, 'Sucesso:', {
              position: 'topRight',
            })
          } else {
            this.$toast.error(response.data.message, 'Error:', {
              position: 'topRight',
            })
          }
        })
        .catch((error) => {
          switch (error.response?.status) {
            case 500:
              this.$toast.error(
                'Erro ao alterar brasão! Por favor, entre em contato com o suporte.',
                'Erro',
                {
                  position: 'topRight',
                }
              )
              break
            default:
              this.$toast.error('Ocorreu um erro inesperado.', 'Erro', {
                position: 'topRight',
              })
              break
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>

<style lang="scss" scoped>
.card-logo {
  max-width: 600px !important;
  margin: 0 auto;
}

.logo-preview-wrapper {
  display: flex;
  justify-content: center;
  gap: 50px;
  margin-bottom: 20px;
  flex-wrap: wrap;
}

.logo-title {
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 10px;
  text-align: center;
  color: #444;
}

.logo-preview img {
  max-height: 120px;
  display: block;
  margin: auto;
}

.example-container {
  margin-top: 25px;
  text-align: center;
}

.example-diagram {
  position: relative;
  width: 140px;
  height: 105px;
  margin: 0 auto;
}

.example-box {
  position: absolute;
  left: 20px;
  top: 20px;
  width: 80px;
  height: 70px;
  border: 2px dashed #bbb;
  background: #f5f5f5;
  box-sizing: border-box;
}

.example-width {
  position: absolute;
  top: 0;
  left: 20px;
  width: 80px;
  text-align: center;
  font-size: 12px;
  color: #666;
}

.example-height {
  position: absolute;
  top: 20px;
  left: 108px;
  height: 70px;
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #666;
}

.example-text {
  font-size: 11px;
  color: #888;
}

.save-button-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-top: 10px;
}
</style>
